var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#98918A",
  strokeWidth: 1.5,
  d: "M10 18.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#98918A",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M7.9 7.9a2.1 2.1 0 1 1 3.2 1.8c-.7.45-1.1.9-1.1 1.7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M10 14.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8"
})));
export default SvgHelp;